export const deleteOwnerMsg =
  'Are you sure you want to detach this change impact owner?';
export const deleteGroupMsg = 'Are you sure you want to detach this group?';
export const deleteUngroupedEmployeeMsg =
  'Are you sure you want to delete this employee?';

const changeUploadStakeholdersMessage =
  'Are you sure you want to switch to another input method? Not saved stakeholders will be lost.';
const changeUploadImpactedMessage =
  'Are you sure you want to switch to another input method? Not saved impacted groups and people will be lost.';

export const findDuplicateIds = (arr, propertyName) => {
  const propertyMap = {};
  const duplicateIds = [];

  arr.forEach((item) => {
    const { draggableId } = item;
    let propertyValue = item[propertyName];

    if (propertyValue) {
      propertyValue = propertyValue?.toLowerCase();

      if (propertyValue in propertyMap) {
        duplicateIds.push(draggableId);
        duplicateIds.push(propertyMap[propertyValue]);
      } else {
        propertyMap[propertyValue] = draggableId;
      }
    }
  });

  return duplicateIds;
};

export const stakeholdersSettingsValidate = (values, columns) => {
  const errors = {};

  const nativeColumn = (key) =>
    columns ? columns.find((column) => column.nativeColumn === key) : {};
  const quadrantKeys = [
    'topLeftQuadrantLabel',
    'topRightQuadrantLabel',
    'bottomLeftQuadrantLabel',
    'bottomRightQuadrantLabel',
  ];

  const nonUniqueNameFieldsIds = findDuplicateIds(columns, 'name', true);
  nonUniqueNameFieldsIds.forEach((id) => {
    errors[id] = 'Duplicate Name';
  });

  columns.map((column) => {
    if (!column.name) {
      errors[column.draggableId] = "Can't be blank";
    }

    if (column.name && !isNaN(column.name)) {
      errors[column.draggableId] = "Field can't start with numbers";
    }
  });

  quadrantKeys.map((key) => {
    if (!values[key]) {
      errors[key] = "Can't be blank";
    }

    if (values[key] && !isNaN(values[key])) {
      errors[key] = "Field can't start with numbers";
    }
  });

  if (!nativeColumn('interest').name) {
    errors.xAxis = 'X axis Label is required';
  }

  if (!isNaN(nativeColumn('interest').name)) {
    errors.xAxis = "Field can't start with numbers";
  }

  if (!nativeColumn('influence').name) {
    errors.yAxis = 'Y axis Label is required';
  }

  if (!isNaN(nativeColumn('influence').name)) {
    errors.yAxis = "Field can't start with numbers";
  }

  return errors;
};

export const changeStrategySettingsValidate = (values, columns) => {
  const errors = {};

  return errors;
};
export const changeImpactValidate = (values, owners) => {
  const errors = {};

  if (!values.title) {
    errors.title = 'Title is required';
  }

  if (!owners.length) {
    errors.owner = 'Owner is required';
  }

  if (!values.change_impact_type_id) {
    errors.change_impact_type_id = 'Impact type is required';
  }

  if (!values.scale) {
    errors.scale = 'Scale is required';
  }

  if (!values.perception) {
    errors.perception = 'Perception is required';
  }

  if (!values.start_date) {
    errors.start_date = 'Start Date is required';
  }

  if (!values.end_date) {
    errors.end_date = 'End Date is required';
  }

  return errors;
};

export const onStakeholdersUploadChange = (method, setUploadMethod) => {
  if (window.confirm(changeUploadStakeholdersMessage)) {
    setUploadMethod(method);
  }
};

export const onImpactedUploadChange = (method, setUploadMethod) => {
  if (window.confirm(changeUploadImpactedMessage)) {
    setUploadMethod(method);
  }
};

export const isAnyProjectActive = (data) => {
  for (const key in data) {
    if (!data[key].archived) {
      return true;
    }
  }
  return false;
};
